// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","caption":"foecgKMv","mobile":"mobile","coverImage":"UQFyTFGF","image":"rzqbtEWG","info":"RMxmW5yU"};